import { render, staticRenderFns } from "./FormatQuestionnaireSubmissionEndpointPropertyEditor.vue?vue&type=template&id=d6f53b7a&scoped=true&"
import script from "./FormatQuestionnaireSubmissionEndpointPropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./FormatQuestionnaireSubmissionEndpointPropertyEditor.vue?vue&type=script&lang=ts&"
import style0 from "./FormatQuestionnaireSubmissionEndpointPropertyEditor.vue?vue&type=style&index=0&id=d6f53b7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f53b7a",
  null
  
)

export default component.exports